import Vue from 'vue'
import Router from 'vue-router'

// Public
import Signup from './views/landing/Signup.vue'
import SignupAgency from './views/landing/SignupAgency.vue'
import SignupConfirm from './views/landing/SignupConfirm.vue'
import Login from './views/landing/Login.vue'
import ForgotPassword from './views/landing/ForgotPassword.vue'
import ResetPassword from './views/landing/ResetPassword.vue'

// Private
import Dashboard from './views/panel/Dashboard/Index.vue'
import RoiDashboard from './views/panel/Dashboard/Roi.vue'
import Activity from './views/panel/Agency/Activity.vue'
import Settings from './views/panel/Settings.vue'
import UserSettings from './views/panel/UserSettings.vue'
import Reviews from './views/panel/Reviews.vue'
import GbpManager from './views/panel/GbpManager.vue'
import Billing from './views/panel/Billing.vue'
import BillingNew from './views/panel/BillingNew.vue'
import Support from './views/panel/Support.vue'
import Locations from './views/panel/Locations.vue'
import Inbox from './views/panel/Inbox.vue'
import InboxThread from './views/panel/InboxThread.vue'
import LsaAudit from './views/panel/LsaAudit.vue'
import RankTracker from './views/panel/RankTracker.vue'
import TestingSuite from './views/panel/TestingSuite.vue'
import OutboundCall from './views/panel/OutboundCall.vue'
import TurboOutbound from './views/panel/TurboOutbound.vue'
import Roadmap from './views/panel/Roadmap.vue'

// Agency components
import Businesses from './views/panel/Agency/Businesses.vue'
import AiAdmin from './views/panel/Agency/AiAdmin.vue'
import Agencies from './views/panel/Agency/Agencies.vue'
import Plans from './views/panel/Agency/Plans.vue'
import PlanForm from './views/panel/Agency/PlanForm.vue'
import AgencySettings from './views/panel/Agency/Settings.vue'
import Resources from './views/panel/Agency/Resources.vue'
import PublicReportStats from './views/panel/Agency/PublicReportStats.vue'
// END Agency components

// Admin components
// import Agencies from './views/panel/Admin/Agencies.vue'
// END Admin components

import EmailVerify from './views/panel/EmailVerify.vue'

// Local Recon
import LocalReconDashboard from './views/local-recon/Dashboard.vue'
import LocalReconLeads from './views/local-recon/Leads.vue'
import LocalReconReports from './views/local-recon/Reports.vue'
import LocalReconWidgets from './views/local-recon/Widgets.vue'
import LocalReconWidgetForm from './views/local-recon/WidgetForm.vue'
import LocalReconReportPublic from './views/local-recon/ReportPublic.vue'
import LocalReconWidgetsRender from './views/local-recon/WidgetsRender.vue'

// Common
import Users from './views/panel/Users.vue'
// Common

// Leads
import AIAgent from './views/panel/AIAgent.vue'
import AiLeadsPublicTable from './views/panel/Call/AiLeadsPublicTable.vue'
import AiLeadsPublicTableSurvey from './views/panel/Call/AiLeadsPublicTableSurvey.vue'
import Refunds from './views/panel/Call/Refunds.vue'
import Radius from './views/panel/Call/Radius.vue'
import LeadsNew from './views/panel/Call/LeadsNew.vue'
import LeadsSeo from './views/panel/Call/LeadsSeo.vue'
import Conv from './views/panel/Call/Conv.vue'
import ProvideFeedback from './views/panel/Call/ProvideFeedback.vue'
import MessageIndex from './views/panel/Call/Messages.vue';

// Other
import Reports from "./views/panel/Reports.vue";
import RollUpReport from "./views/panel/RollUpReport.vue";
// import NewAgencySettingsTwo from "./views/panel/NewAgencySettingsTwo.vue";


import Privacy from "./views/landing/Privacy.vue";
import Terms from "./views/landing/Terms.vue";


import Usage from './views/panel/Admin/Usage.vue';
import OnboardingSetup from './views/panel/Onboarding.vue';
import Onboarding from './views/panel/OnboardingChecklist.vue';
import OptimizationAgent from './views/panel/OptimizationAgent.vue';
import AgencyStart from './views/panel/Agency/AgencyStart.vue';

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: function (to) {
    if (to.hash) {
      return { selector: to.hash }
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Dashboard
    },

    {
      path: '/',
      name: 'InboxThread',
      component: InboxThread
    },

    {
      path: '/chat',
      name: 'InboxThread',
      component: InboxThread
    },

    {
      path: "/reports",
      name: "reports",
      component: Reports,
    },
    {
      path: "/roll-up-report",
      name: "roll-up-report",
      component: RollUpReport,
    },
    {
      path: "/lsa-audit",
      name: "lsa-audit",
      component: LsaAudit,
    },
    {
      path: "/rank-tracker",
      name: "rank-tracker",
      component: RankTracker,
    },
    {
      path: "/rank-tracker/:id",
      name: "rank-tracker-public",
      component: RankTracker,
    },
    {
      path: "/testing-suite",
      name: "testing-suite",
      component: TestingSuite,
    },
    {
      path: "/outbound-call",
      name: "outbound-call",
      component: OutboundCall,
    },
    {
      path: "/turbo-outbound",
      name: "turbo-outbound",
      component: TurboOutbound,
    },
    {
      path: "/roadmap",
      name: "roadmap",
      component: Roadmap,
    },
    {
      path: '/signup',
      name: 'signup',
      component: Signup
    },
    {
      path: '/signup-agency',
      name: 'signup-agency',
      component: SignupAgency
    },
    {
      path: '/signup/plan/:plan_id',
      name: 'signup_plan',
      component: Signup
    },
    {
      path: '/signup/:company_type/plan/:plan_id',
      name: 'signup_company_type',
      component: Signup
    },
    {
      path: '/signup/confirm',
      name: 'signup_confirm',
      component: SignupConfirm
    },
    {
      path: '/welcome',
      name: 'welcome',
      component: SignupConfirm
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: ForgotPassword
    },
    {
      path: '/reset-password/:token',
      name: 'reset-password',
      component: ResetPassword
    },
    {
      path: '/privacy-policy',
      name: 'privacypolicy',
      component: Privacy
    },
    {
      path: '/terms-of-service',
      name: 'termsofservice',
      component: Terms
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard
    },
    {
      path: '/dashboard/roi',
      name: 'roi_dashboard',
      component: RoiDashboard
    },
    {
      path: '/activity',
      name: 'activity',
      component: Activity
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings
    },
    {
      path: '/optimization',
      name: 'optimization',
      component: OptimizationAgent
    },
    {
      path: '/onboarding',
      name: 'onboarding',
      component: Onboarding
    },
    { path: '/onboarding/setup', name: 'onboarding-setup', component: OnboardingSetup },
    {
      path: '/onboarding/setup',
      name: 'onboarding-setup',
      component: OnboardingSetup
    },
    {
      path: '/agency-start',
      name: 'agency-start',
      component: AgencyStart
    },
    {
      path: '/settings/settings',
      name: 'settings2',
      component: Settings
    },
    {
      path: '/user-settings',
      name: 'user-settings',
      component: UserSettings
    },
    {
      path: '/reviews',
      name: 'reviews',
      component: Reviews
    },
    {
      path: '/settings/reviews',
      name: 'settings_reviews',
      component: Reviews
    },
    {
      path: '/settings/gbp',
      name: 'settings_gbp',
      component: GbpManager
    },
    {
      path: '/billing',
      name: 'billing',
      component: Billing
    },
    {
      path: '/billing-settings',
      name: 'billing-new',
      component: BillingNew
    },
    {
      path: '/support',
      name: 'support',
      component: Support
    },
    {
      path: '/auth/:provider/callback',
      component: {
        template: '<div class="auth-component"></div>'
      }
    },
    {
      path: '/locations',
      name: 'locations',
      component: Locations
    },

    // Agency routes
    {
      path: '/businesses',
      name: 'businesses',
      component: Businesses
    },

    {
      path: '/ai-admin',
      name: 'ai_admin',
      component: AiAdmin
    },

    {
      path: '/plans',
      name: 'plans',
      component: Plans
    },

    {
      path: '/plans/create',
      name: 'create_plan',
      component: PlanForm
    },

    {
      path: '/plans/edit/:id',
      name: 'plans_edit',
      component: PlanForm
    },

    {
      path: '/refer-and-earn',
      name: 'refer-and-earn',
      component: () => import('@/views/panel/Agency/ReferAndEarn.vue')
    },
    {
      path: '/agency-settings',
      name: 'agency-settings',
      component: AgencySettings
    },
    {
      path: '/resources',
      name: 'resources',
      component: Resources
    },
    {
      path: '/public-report-stats',
      name: 'public-report-stats',
      component: PublicReportStats
    },
    // END Agency routes

    // Admin routes
    {
      path: '/agencies',
      name: 'agencies',
      component: Agencies
    },
    // END Admin routes

    {
      path: '/email/verify/:user_id/:token',
      name: 'email-verify',
      component: EmailVerify
    },


    // Local Recon Routes
    {
      path: '/local-recon/dashboard',
      name: 'local_recon_dashboard',
      component: LocalReconDashboard
    },
    {
      path: '/local-recon/leads',
      name: 'local_recon_leads',
      component: LocalReconLeads
    },
    {
      path: '/local-recon/reports',
      name: 'local_recon_reports',
      component: LocalReconReports
    },
    {
      path: '/local-recon/widgets',
      name: 'local_recon_widgets',
      component: LocalReconWidgets
    },
    {
      path: '/local-recon/widgets/create',
      name: 'local_recon_widgets_create',
      component: LocalReconWidgetForm
    },
    {
      path: '/local-recon/widgets/edit/:token',
      name: 'local_recon_widgets_edit',
      component: LocalReconWidgetForm
    },
    {
      path: '/local-recon/widgets/edit/:token/:action',
      name: 'local_recon_widgets_edit_token',
      component: LocalReconWidgetForm
    },
    {
      path: '/rf',
      name: 'local_recon_report',
      component: LocalReconReportPublic
    },
    {
      path: '/local-recon/widgets/render/:token',
      name: 'widgets_render_local_recon',
      component: LocalReconWidgetsRender
    },
    // END Local Recon Routes

    // Call Tracking Routes
    {
      path: '/leads/messages',
      name: 'MessageIndex',
      component: MessageIndex
    },
    {
      path: '/leads',
      name: 'LeadsNew',
      component: LeadsNew
    },
    {
      path: '/leads-public/:uuid',
      name: 'AiLeadsPublicTable',
      component: AiLeadsPublicTable
    },
    {
      path: '/leads-public-survey/:uuid',
      name: 'AiLeadsPublicTableSurvey',
      component: AiLeadsPublicTableSurvey
    },
    {
      path: '/leads-public-survey',
      name: 'AiLeadsPublicTableSurvey2',
      component: AiLeadsPublicTableSurvey
    },
    {
      path: '/settings/refunds',
      name: 'Refunds',
      component: Refunds
    },
    {
      path: '/settings/radius',
      name: 'Radius',
      component: Radius
    },
    {
      path: '/leads-seo',
      name: 'LeadsNewSeo',
      component: LeadsSeo
    },
    {
      path: '/ai-agent',
      name: 'AIAgent',
      component: AIAgent
    },
    {
      path: '/settings/ai-agent',
      name: 'AIAgentSettings',
      component: AIAgent
    },
    {
      path: '/convt',
      name: 'Conv',
      component: Conv
    },
    {
      path: '/provide-feedback',
      name: 'ProvideFeedback',
      component: ProvideFeedback
    },

    // END Call Tracking Routes

    // Common routes
    {
      path: '/users',
      name: 'users',
      component: Users
    },

    {
      path: '/inbox',
      name: 'Inbox',
      component: Inbox
    },

    {
      path: '/videos',
      name: 'videos',
      component: () => import('@/views/panel/VideoTutorialsPage.vue')
    },

    {
      path: '/usage',
      name: 'usage',
      component: Usage
    },
  ]
})
